import React from 'react'

import { useEventContext } from 'context/EventContext'

import Tab from './components/Tab'

import classes from './Navigation.module.scss'

const EVENT_ACTION_DICTIONARY = {
  serp_category: 'category_all-products',
  serp_category_leaders: 'category_leaders',
}

const getEngagementDestination = ({ slug, route_name }) => {
  if (slug === 'guide') {
    return `jump-to_${EVENT_ACTION_DICTIONARY.serp_category}_guide`
  }

  return `go-to_${EVENT_ACTION_DICTIONARY[route_name] || route_name}`
}

/** @type {import("./types").default} */
const Navigation = ({ navigationTabs }) => {
  const { addEvent } = useEventContext({
    engagementComponent: 'navigation-bar',
    name: 'engagement_navigation',
  })

  return (
    <nav className={classes.root} role="tablist" aria-label="Product navigation">
      {navigationTabs.map(tab => (
        <Tab
          href={tab.url}
          key={tab.slug}
          className={!!tab.active && classes.active}
          label={<span className={classes.label}>{tab.label}</span>}
          {...addEvent({
            engagementComponent: 'navigation-bar',
            engagementDestination: getEngagementDestination(tab),
            engagementDetails: 'navigation-tab',
            name: 'engagement_navigation',
          })}
        />
      ))}
    </nav>
  )
}

export default Navigation
